import { Capacitor } from '@capacitor/core';

const LOCAL_API_URL = 'http://127.0.0.1:3031';
const WEB_API_PATH = '/api';
const REMOTE_API_URL = 'https://api.yubumarket.com';

function isLocalHost() {
  if (typeof window === 'undefined') return false;

  const { hostname } = window.location;
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '::1' ||
    hostname === '[::1]'
  );
}

function resolveDefaultApiUrl() {
  // Native Capacitor builds should always use the deployed backend.
  if (Capacitor.isNativePlatform()) {
    return REMOTE_API_URL;
  }

  // Browser and installed PWA builds should use the local backend only when
  // the app itself is being served locally. In production web, route through
  // the same-origin reverse proxy to avoid cross-origin drift during domain moves.
  return isLocalHost() ? LOCAL_API_URL : WEB_API_PATH;
}

const defaultUrl = resolveDefaultApiUrl();

export const API_URL = import.meta.env.VITE_API_URL || defaultUrl;

// Web Push VAPID key — from Firebase Console → Project Settings → Cloud Messaging → Web Push certificates
export const VAPID_KEY = 'BIjCaEPHMPX5nq1HIe-vCKOGfbxoci4r-2OuTA3u6dko-M5r_dilVQ08EAEeXh6xxqlif3bTjzMrnVDWm9fJjjA';

export default API_URL;
